import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: ${({ stack }) => (stack ? 'column' : 'row')};
  gap: 1em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    flex-direction: column;
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const SuggestionDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 160px;
  border: 1px ${({ theme }) => theme.colors.N40} solid;
  z-index: 10;
`;

export const StyledSuggestionItem = styled.div`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background-color: ${({ theme }) => theme.colors.N0};

  &:hover {
    background-color: ${({ theme }) => theme.colors.N20};
    cursor: pointer;
  }
`;
